import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Activity, Menu, X } from "lucide-react";
import { useState } from "react";
import { dashboardPathFor } from "@/lib/uiConstants";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/features", label: "Features" },
  { to: "/pricing", label: "Pricing" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const { user } = useAuth() || {};
  const loc = useLocation();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const dashboardPath = dashboardPathFor(user);

  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-zinc-200">
      <div className="container-x flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="w-9 h-9 rounded-md flex items-center justify-center" style={{ background: "var(--ink)" }}>
            <Activity className="w-5 h-5" style={{ color: "var(--gold)" }} />
          </span>
          <span className="font-extrabold text-lg tracking-tight">Sonote<span style={{ color: "var(--gold)" }}>™</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                loc.pathname === n.to ? "text-zinc-900 bg-zinc-100" : "text-zinc-600 hover:text-zinc-900 hover:bg-zinc-50"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <button onClick={() => nav(dashboardPath)} data-testid="nav-dashboard" className="btn-gold h-10 px-5 text-sm">
              Go to Dashboard
            </button>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="btn-ghost text-sm">Log in</Link>
              <Link to="/register" data-testid="nav-register" className="btn-gold h-10 px-5 text-sm">Start free trial</Link>
            </>
          )}
        </div>
        <button onClick={() => setOpen(!open)} className="md:hidden p-2" data-testid="nav-menu-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-zinc-200 bg-white">
          <div className="container-x py-4 flex flex-col gap-2">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="py-2 text-zinc-700">
                {n.label}
              </Link>
            ))}
            {user ? (
              <button onClick={() => { setOpen(false); nav(dashboardPath); }} className="btn-gold mt-2">Go to Dashboard</button>
            ) : (
              <Link to="/register" onClick={() => setOpen(false)} className="btn-gold mt-2 text-center">Start free trial</Link>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
